import { AxiosError } from 'axios';
import get from 'lodash/get';
import { captureMessageInSentry } from 'lib/captureInSentry';
import redirectToRelationship from 'lib/graphql/helpers/redirectToRelationship';

interface Options {
  operationName: string;
  skipUnauthenticatedRedirection?: boolean;
}

export const handleServiceError = (error: unknown, { operationName, skipUnauthenticatedRedirection }: Options) => {
  const axiosError = error as AxiosError;
  const status = get(axiosError, 'response.status');
  const message = axiosError instanceof Error ? axiosError.message : String(error);

  captureMessageInSentry(`REST ${operationName} failed: ${message}`, {
    status,
  });

  if (status === 401 && !skipUnauthenticatedRedirection) {
    redirectToRelationship();
    return;
  }

  throw error;
};
